export default "__VITE_ASSET__BXh4bqW9__"